<template>
  <div class="solar-gallery">
    <!-- Trigger Component -->
    <div class="solar-gallery__trigger" @click="openModal">
      <div class="solar-gallery__content">
        <div class="solar-gallery__text">
          <h4 class="solar-gallery__title">Finansuojama Europos Sąjunga</h4>
          <p class="solar-gallery__subtitle">Spausti, kad peržiūrėti galeriją</p>
        </div>
        <div class="solar-gallery__logo">
          <img 
            :src="euLogo" 
            alt="Finansuojama Europos Sąjunga" 
            class="solar-gallery__logo-img"
          />
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div 
      v-if="isModalOpen" 
      class="solar-modal-overlay"
      @click.self="closeModal"
    >
      <div class="solar-modal">
        <div class="solar-modal__header">
          <button class="solar-modal__close" @click="closeModal" aria-label="Uždaryti">
            ×
          </button>
        </div>
        <div class="solar-modal__body">
          <div class="solar-modal__description">
            <div class="solar-modal__logo-container">
              <img 
                :src="euLogo" 
                alt="Finansuojama Europos Sąjunga" 
                class="solar-modal__logo"
              />
            </div>
            <p class="solar-modal__description-text">
              Jungtinio projekto projektas įgyvendinamas pagal ekonomikos gaivinimo ir atsparumo didinimo planą „Naujos kartos Lietuva", finansuojamą Europos Sąjungos ekonomikos gaivinimo ir atsparumo didinimo priemonės „NextGenerationEU" lėšomis.
            </p>
          </div>
          <div class="solar-modal__gallery">
            <div 
              v-for="(image, index) in images" 
              :key="index"
              class="solar-modal__gallery-item"
            >
              <img 
                :src="image" 
                :alt="`Saulės energijos nuotrauka ${index + 1}`"
                class="solar-modal__image"
                @click="openImageModal(image)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Full Image Modal -->
    <div 
      v-if="selectedImage" 
      class="solar-image-modal-overlay"
      @click="closeImageModal"
    >
      <div class="solar-image-modal">
        <button class="solar-image-modal__close" @click="closeImageModal" aria-label="Uždaryti">
          ×
        </button>
        <img 
          :src="selectedImage" 
          alt="Didelė nuotrauka"
          class="solar-image-modal__image"
        />
      </div>
    </div>
  </div>
</template>

<script>
import euLogo from '@/assets/solar/financed-by-eu.jpg'
import solarSide from '@/assets/solar/solar-side.jpg'
import solarSideUp from '@/assets/solar/solar-side-up.jpg'
import solarSideDown from '@/assets/solar/solar-side-down.jpg'

export default {
  name: 'SolarGallery',
  data() {
    return {
      isModalOpen: false,
      selectedImage: null,
      euLogo,
      images: [
        solarSide,
        solarSideUp,
        solarSideDown
      ]
    }
  },
  methods: {
    openModal() {
      this.isModalOpen = true
      document.body.style.overflow = 'hidden'
    },
    closeModal() {
      this.isModalOpen = false
      document.body.style.overflow = ''
    },
    openImageModal(image) {
      this.selectedImage = image
    },
    closeImageModal() {
      this.selectedImage = null
    }
  },
  watch: {
    isModalOpen(newVal) {
      if (!newVal && this.selectedImage) {
        this.selectedImage = null
      }
    },
    selectedImage(newVal) {
      if (newVal) {
        document.body.style.overflow = 'hidden'
      } else if (!this.isModalOpen) {
        document.body.style.overflow = ''
      }
    }
  },
  beforeUnmount() {
    document.body.style.overflow = ''
  }
}
</script>

<style scoped>
.solar-gallery {
  position: relative;
}

.solar-gallery__trigger {
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  border-radius: 12px;
  overflow: hidden;
}

.solar-gallery__trigger:hover .solar-gallery__content {
  transform: translateY(-4px);
  box-shadow: 0 12px 35px rgba(220, 53, 69, 0.4);
}

.solar-gallery__content {
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 24px 28px;
  background: linear-gradient(135deg, #dc3545 0%, #ff6b6b 100%);
  color: white;
  border-radius: 16px;
  box-shadow: 0 8px 25px rgba(220, 53, 69, 0.3);
  transition: all 0.3s ease;
}

.solar-gallery__text {
  flex: 1;
}

.solar-gallery__title {
  margin: 0 0 8px 0;
  font-size: 1.25rem;
  font-weight: 700;
}

.solar-gallery__subtitle {
  margin: 0;
  font-size: 0.9rem;
  opacity: 0.9;
}

.solar-gallery__logo {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.solar-gallery__logo-img {
  height: 100px;
  width: auto;
  max-width: 100%;
  object-fit: contain;
  border-radius: 4px;
}

/* Modal Styles */
.solar-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  overflow-y: auto;
}

.solar-modal {
  background: #fff;
  border-radius: 12px;
  max-width: 1200px;
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.solar-modal__header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 24px 28px;
  border-bottom: 1px solid #e5e5e5;
}

.solar-modal__close {
  background: linear-gradient(135deg, #dc3545, #ff6b6b);
  border: none;
  font-size: 24px;
  line-height: 1;
  color: white;
  cursor: pointer;
  padding: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
}

.solar-modal__close:hover {
  transform: scale(1.1) rotate(90deg);
  box-shadow: 0 6px 20px rgba(220, 53, 69, 0.4);
}

.solar-modal__body {
  padding: 28px;
  overflow-y: auto;
  flex: 1;
}

.solar-modal__description {
  margin-bottom: 28px;
  padding-bottom: 28px;
  border-bottom: 2px solid #e5e5e5;
  text-align: center;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.solar-modal__logo-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.solar-modal__logo {
  max-height: 100px;
  max-width: 350px;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 4px;
}

.solar-modal__description-text {
  margin: 0;
  font-size: 1rem;
  line-height: 1.7;
  color: #1a1a1a;
  text-align: center;
  font-family: 'Open Sans', sans-serif;
}

.solar-modal__gallery {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
}

.solar-modal__gallery-item {
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  aspect-ratio: 4/3;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.solar-modal__gallery-item:hover {
  transform: translateY(-5px) scale(1.02);
  box-shadow: 0 8px 25px rgba(220, 53, 69, 0.3);
}

.solar-modal__gallery-item::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(220, 53, 69, 0.1), rgba(255, 107, 107, 0.1));
  opacity: 0;
  transition: opacity 0.3s ease;
}

.solar-modal__gallery-item:hover::after {
  opacity: 1;
}

.solar-modal__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* Full Image Modal */
.solar-image-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.95);
  z-index: 10001;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
}

.solar-image-modal {
  position: relative;
  max-width: 95vw;
  max-height: 95vh;
}

.solar-image-modal__close {
  position: absolute;
  top: -40px;
  right: 0;
  background: none;
  border: none;
  font-size: 40px;
  line-height: 1;
  color: #fff;
  cursor: pointer;
  padding: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s;
  z-index: 10002;
}

.solar-image-modal__close:hover {
  opacity: 0.7;
}

.solar-image-modal__image {
  max-width: 100%;
  max-height: 95vh;
  object-fit: contain;
  border-radius: 8px;
}

@media (max-width: 768px) {
  .solar-gallery__content {
    flex-direction: column;
    text-align: center;
    padding: 16px;
  }

  .solar-gallery__logo-img {
    height: 70px;
    max-width: 100%;
  }

  .solar-modal__logo {
    max-height: 70px;
    max-width: 280px;
  }

  .solar-modal {
    max-height: 95vh;
    border-radius: 12px 12px 0 0;
    margin-top: auto;
  }
  
  .solar-modal__header,
  .solar-modal__body {
    padding: 20px;
  }

  .solar-modal__gallery {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .solar-image-modal-overlay {
    padding: 20px;
  }

  .solar-image-modal__close {
    top: -30px;
    font-size: 32px;
  }
}
</style>
